import React from 'react'
import { createRoot } from 'react-dom/client'

// Rediseño (Fase 1): tokens primero (variables), y antd UNA sola vez, antes de los estilos propios (H06).
// antd 5 (paso 2c) ya no publica `antd/dist/antd.css`: sus estilos van en JS y solo
// queda el reset. Los overrides del sistema siguen ganando porque antd 5 envuelve
// sus selectores en :where(), que tiene especificidad cero.
import './styles/tokens.css'
import 'antd/dist/reset.css'

import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ReactNotifications } from 'react-notifications-component'

// React 18 (paso 2 de docs/MODERNIZACION.md): `ReactDOM.render` está retirado y
// se sustituye por `createRoot`. No se envuelve en <StrictMode> a propósito: en
// desarrollo montaría cada efecto dos veces y este código tiene efectos sin
// limpieza (H03 socket al importar, H04 listeners del header), así que hoy
// provocaría fallos que no son del rediseño. Se valorará al resolver esos hallazgos.
const contenedor = document.getElementById('root')
const raiz = createRoot(contenedor)

raiz.render(
  <React.Fragment>
    <ReactNotifications />
    <App />
  </React.Fragment>,
)

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
